import React from 'react';
import {TableCell} from '@mui/material';
import TableHeader from '@crema/core/AppTable/TableHeader';
import PropTypes from 'prop-types';

const TableHeading = ({headings}) => {
  const updatedHeadings = [...headings, ''];

  return (
    <TableHeader>
      {updatedHeadings.map((updatedHeadings) => {
        return (
          <TableCell key={updatedHeadings} align='left'>
            {updatedHeadings}
          </TableCell>
        );
      })}
    </TableHeader>
  );
};
TableHeading.propTypes = {
  headings: PropTypes.array.isRequired,
};
export default TableHeading;
